/** Tipifica erros ao carregar páginas lazy; não inclui URLs nem credenciais no resultado. */
export function isRouteChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return /failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module|loading chunk [^\n]+ failed|chunkloaderror/i.test(message);
}
